<template>
  <div>
    <label for="">{{ label }} {{ required ? '*' : '' }} </label>
    <v-file-input
        v-model="file"
        :rules="[...isRequired,...rules]"
        class="q-text-field file-input"
        dense
        hide-details="auto"
        outlined
        prepend-icon=""
        @change="updateValue"
    >
      <template v-slot:selection="{ text }">
        <p class="file-chip mb-0">
          {{ text }}
        </p>
      </template>
      <template #prepend-inner>
        <SvgIcon>
          <template #icon>
            <FileIcon/>
          </template>
        </SvgIcon>
      </template>
    </v-file-input>
    <a v-if="defaultValue" :href="s3BucketURL+defaultValue" class="text-black mt-2 d-block w-fit" target="_blank">
      <p class="file-chip mb-0">
        {{ truncateText(defaultValue) }}
      </p>
    </a>
  </div>
</template>

<script>

import SvgIcon from "@/components/Image/SvgIcon.vue";
import FileIcon from "@/assets/images/venues/file.svg"

export default {
  name: "FileInput",
  components: {SvgIcon, FileIcon},
  props: {
    value: {
      default: null
    },
    label: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: String,
      default: null
    }
  },
  computed: {
    isRequired() {
      return this.required ? [(v) => !!v || `${this.label} is required`] : [];
    }
  },
  data() {
    return {
      file: this.value
    };
  },
  watch: {
    value(newValue) {
      this.file = newValue;
    }
  },
  methods: {
    truncateText(text) {
      if (typeof text === 'string') {
        return text.slice(-15);
      }
      return '';
    },
    updateValue(file) {
      this.$emit('input', file);
    }
  }
};
</script>

<style>
.file-input {
  .v-input__prepend-inner {
    margin: auto !important;
  }
}
</style>
